import { store } from '../../index';
import { apiPost, apiPostQs } from '../../api/ServiceManager';
import {
    TOKEN_KEY, CART_DATA, REQUEST_ORDER,  OPEN_ORDER, CAMERA_IMG_URL,
    PROFILE_IMG_URL, SAVE_SHARE_IMAGE, GET_USER_DETAILS, UPDATE_USER_DETAILS} from "../../utils/constant";
import { cravrrOrderDataSet } from "../../utils/helper";
import {
  get_item_list,
  get_category,
  get_addon_list,
} from "../../utils/item_helper";
import { recalculateItemsForChannel } from "../../utils/order_helper";

const item_list = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'ITEM_LIST',
			item_list: data,
		});
	};
};

const item_verriant_list = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'ITEM_VERRIANTS',
			item_verriants: data,
		});
	};
};

const associated_stores = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'ASSOCIATED_STORES',
			associated_stores: data,
		});
	};
};

const web_login = ({ token, store_id, location_id, table_details, store_details, store_config }) => {
	return (dispatch) => {
		dispatch({
			type: 'WEB_LOGIN',
			payload: { token, store_id, location_id, table_details, store_details, store_config },
		});
	};
};

const web_logout = () => {
	return (dispatch) => {
		dispatch({ type: 'WEB_LOGOUT' });
		dispatch({ type: 'CLEAR_STATE_DATA' });
	};
};

const get_store_configs= (data) => {
	return (dispatch) => {
		dispatch({
			type: 'STORE_CONFIG',
			storeConfig: data,
		});
	};
};

const set_filters = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'FILTERS',
			appliedfilters : data,
		});
	};
};

const item_category = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'CATEGORY_LIST',
			catagory : data,
		});
	};
};

const addon_list = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'ADDON_LIST',
			addon: data,
		});
	};
};

const label_list = (data) => {
	return (dispatch) => {
		dispatch({
			type: 'LABEL_LIST',
			labels: data,
		});
	};
};

const order_request = () => {
	return (dispatch, getState) => {
		const data = getState();
		const cravrrObj = cravrrOrderDataSet(data);
		console.log('data ', data);
		console.log('cravrrObj ', cravrrObj);
		dispatch({
			type: 'ORDER_REQUEST',
			orderRequest: { cravrrObj },
		});
	};
};

const captured_image = (capturedImage) => {
	return (dispatch) => {
		dispatch({
			type: 'CAPTURED_IMAGE',
			capturedImage,
		});
	};
};

const set_tender = (tender) => {
	return (dispatch) => {
		dispatch({
			type: 'SET_TENDER',
			selectedTender: tender,
		});
	};
};


const set_customer = (customer) => {
	return (dispatch) => {
		dispatch({
			type: 'SET_CUSTOMER',
			customer,
		});
	};
};
const set_last_order = (last_order) => {
	return (dispatch) => {
		dispatch({
			type: 'SET_LAST_ORDER',
			last_order,
		});
	};
};

const clear_last_order = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_LAST_ORDER',
		});
	};
};

const clear_customer = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_CUSTOMER',
		});
	};
};

const clear_associated_store = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_ASSOCIATED_STORE',
		});
	};
};

const order_place = (orderPlace) => {
	return (dispatch) => {
		dispatch({
			type: 'ORDER_PLACE',
			orderPlace,
		});
	};
};

const clear_order_details = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_ORDER_DETAILS',
		});
	};
};

const clear_order_type = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_ORDER_TYPE',
		});
	};
};

const clear_applied_offer = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_APPLIED_OFFERS',
		});
	};
};


const clear_order_request = () => {
	return (dispatch) => {
		dispatch({
			type: 'CLEAR_ORDER_REQUEST',
		});
	};
};

const set_order_type = (orderType) => {
	return async (dispatch, getState) => {
		dispatch({
			type: 'SET_ORDER_TYPE',
			orderType,
		});

		const activeChannelCode = orderType?.order?.order_code;

		if (activeChannelCode) {
			try {
				await dispatch(preload_menu_data());
			} catch (e) {
				console.error("Error refreshing catalog on order type change:", e);
			}

			try {
				const state = getState();
				const addedItems = state.cartReducer?.addedItems || [];
				const catalogByStore = state.catalogReducer?.by_store || {};
				const defaultStoreId = state.sessionReducer?.store_details?.store_id || state.filterReducer?.selected_store?.store_id;

				if (addedItems.length > 0) {
					const updatedItems = recalculateItemsForChannel(
						addedItems,
						catalogByStore,
						activeChannelCode,
						defaultStoreId
					);

					dispatch({
						type: 'UPDATE_CART_ITEM_PRICES',
						items: updatedItems,
					});
				}
			} catch (e) {
				console.error("Error updating cart item prices for channel:", e);
			}
		}
	};
};

const set_user = (user) => {
	return (dispatch) => {
		let param = {
			Name: user.name,
			EmailID: user.email,
			Provider: user.provider,
			ProviderPic: user.provider_pic,
			ProviderId: user.provider_id,
		};
		console.log(
			'@@@@@@@@@@ GET_USER_DETAILS - request :: ',
			JSON.stringify(param)
		);
		apiPost(
			GET_USER_DETAILS,
			param,
			(resp) => {
				console.log(
					'@@@@@@@@@@ GET_USER_DETAILS - Response ::',
					JSON.stringify(resp.User)
				);
				if (resp.User.SocialProviderPic.indexOf('http') === -1) {
					resp.User.SocialProviderPic =
						PROFILE_IMG_URL + resp.User.SocialProviderPic;
				}
				dispatch({
					type: 'SET_USER',
					user: resp.User,
				});
			},
			(err) => {
				console.log('GET_USER_DETAILS API error  :::::::::::: ', err.message);
			}
		);
	};
};

const update_user = (formData) => {
	return (dispatch) => {
		console.log(
			'@@@@@@@@@@ UPDATE_USER_DETAILS - request :: ',
			JSON.stringify(formData)
		);
		apiPostQs(
			UPDATE_USER_DETAILS,
			formData,
			(resp) => {
				console.log(
					'@@@@@@@@@@ UPDATE_USER_DETAILS - Response ::',
					JSON.stringify(resp.User)
				);
				if (resp.User.SocialProviderPic.indexOf('http') === -1) {
					resp.User.SocialProviderPic =
						PROFILE_IMG_URL + resp.User.SocialProviderPic;
				}
				dispatch({
					type: 'SET_USER',
					user: resp.User,
				});
			},
			(err) => {
				console.log(
					'UPDATE_USER_DETAILS API error  :::::::::::: ',
					err.message
				);
			}
		);
	};
};

const clearStateData = () => {
	return (dispatch) => {
		localStorage.removeItem(CART_DATA);
		localStorage.removeItem(REQUEST_ORDER);
		localStorage.removeItem(OPEN_ORDER);
		dispatch({
			type: 'CLEAR_STATE_DATA',
			clearStatus: true,
		});
	};
};

const store_details = (data) => {
    let store = store.getState().sessionReducer?.store_details || {};
	return async (dispatch) => {
		dispatch({
            type: 'STORE_DETAILS',
            storeInfo: store,
        });
	};
};

const store_configs= (data) => {
    let storeConfig = store.getState().sessionReducer.store_config || {};
	return async (dispatch) => {
		dispatch({
            type: 'STORE_CONFIG',
            storeInfoConfig: storeConfig,
        });
	};
};

const store_offers = (data) => {
    return async (dispatch) => {
        dispatch({
            type: "STORE_OFFERS",
            storeOffer: data,
        });
    };
};

const customer_membership = (data) => {
    return async (dispatch) => {
        dispatch({
            type: "CUSTOMER_MEMBERSHIP",
            customerMembership: data,
        });
    };
};

const applied_offer= (appliedOffer) => {
    return async (dispatch) => {
        dispatch({
            type: "SET_APPLIED_OFFERS",
            appliedOffer
        });
    };
};

const save_share_image = (formData) => {
	console.log('formDataformData == ', JSON.stringify(formData));
	return (dispatch) => {
		apiPostQs(
			SAVE_SHARE_IMAGE,
			formData,
			(resp) => {
				console.log('SAVE_SHARE_IMAGE API error  :::::::::::: ', resp);
				dispatch({
					type: 'CAPTURED_IMAGE',
					capturedImage: { uri: CAMERA_IMG_URL + resp.fileName },
				});
			},
			(err) => {
				console.log('SAVE_SHARE_IMAGE API error  :::::::::::: ', err.message);
			}
		);
	};
};

let isPreloading = false;

const preload_menu_data = () => {
	return async (dispatch, getState) => {
		if (isPreloading) {
			console.log('[preload] skip — already running');
			return;
		}
		isPreloading = true;

		try {
			const state = getState();
			const reducerState = state.customerReducer;
			const sessionState = state.sessionReducer;

			const storeInfo = sessionState?.store_details;
			const storeInfoConfig = sessionState?.store_config;
			const storesData = sessionState?.associated_stores || [];

			console.log('[preload] entry', {
				session_token: !!sessionState?.token,
				session_store_id: sessionState?.store_id,
				storeInfo_store_id: storeInfo?.store_id,
				is_multi_store_qr: storeInfoConfig?.web_ordering_setting?.is_multi_store_qr,
				associated_store_qr: storeInfoConfig?.web_ordering_setting?.associated_store_qr,
				associated_stores_count: storesData.length,
			});

			if (!storeInfo) {
				console.log('[preload] EXIT — no storeInfo');
				return;
			}

		const store_id = storeInfo.store_id;
		const is_multi_store_qr = storeInfoConfig?.web_ordering_setting?.is_multi_store_qr;

		// Determine stores to fetch — for multi-store QR, fan out across all
		// child stores from sessionReducer.associated_stores (populated by login).
		let _storesToFetch = [];
		if (is_multi_store_qr) {
			const qr_stores = storeInfoConfig?.web_ordering_setting?.associated_store_qr;
			if (Array.isArray(qr_stores) && qr_stores.length > 0) {
				const targetIds = qr_stores
					.map((item) => (typeof item === "object" ? item?.store_id : item))
					.filter(Boolean);
				_storesToFetch = targetIds
					.map((id) => storesData.find((s) => String(s?.store_id) === String(id)))
					.filter(Boolean);
			} else {
				_storesToFetch = storesData;
			}
			if (!_storesToFetch.find((s) => String(s.store_id) === String(store_id))) {
				_storesToFetch.push({ store_id: store_id });
			}
		} else {
			_storesToFetch = [{ store_id: store_id }];
		}
		console.log('[preload] stores to fetch', {
			count: _storesToFetch.length,
			ids: _storesToFetch.map((s) => s?.store_id),
		});

		const sessionToken = sessionState?.token;
		const sessionStoreId = sessionState?.store_id;

		// Parallel: items + categories (global, one call each) + addons (per store).
		const [allGlobalItems, allGlobalCategories, ...perStoreAddonArrays] = await Promise.all([
			get_item_list({ token: sessionToken, store_id: sessionStoreId }).then((r) => Array.isArray(r) ? r : []),
			get_category({ token: sessionToken, store_id: sessionStoreId }).then((r) => Array.isArray(r) ? r : []),
			..._storesToFetch.map((s) =>
				get_addon_list({ token: sessionToken, store_id: s.store_id }).then((r) => Array.isArray(r) ? r : [])
			),
		]);
		console.log('[preload] fetched', {
			items: allGlobalItems.length,
			categories: allGlobalCategories.length,
			addons_per_store: perStoreAddonArrays.map((a) => a.length),
		});

		// Merge addons, dedupe by addon_group_id.
		const allAddonsFlat = perStoreAddonArrays.flat();

		// --- Day/time scheduler filtering ---
		const timeZone = storeInfo?.store_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
		const now = new Date();
		const currentDay = new Intl.DateTimeFormat("en-US", { weekday: "long", timeZone }).format(now).toLowerCase();
		const timeParts = new Intl.DateTimeFormat("en-US", {
			hour: "2-digit", minute: "2-digit", hour12: false, hourCycle: "h23", timeZone,
		}).formatToParts(now);
		let hour = timeParts.find((p) => p.type === "hour")?.value || "00";
		if (hour === "24") hour = "00";
		hour = hour.padStart(2, "0");
		let minute = timeParts.find((p) => p.type === "minute")?.value || "00";
		minute = minute.padStart(2, "0");
		const currentTime = `${hour}:${minute}`;
		const passesScheduler = (rec) => {
			if (!rec?.scheduler || !Array.isArray(rec.scheduler) || rec.scheduler.length === 0) return true;
			return rec.scheduler.some((sched) => {
				if (sched?.status === false) return false;
				if (!sched?.day_slots || !Array.isArray(sched.day_slots)) return false;
				return sched.day_slots.some((ds) => {
					if (ds?.day?.toLowerCase() !== currentDay) return false;
					if (!ds?.slots || !Array.isArray(ds.slots)) return false;
					return ds.slots.some((slot) => {
						const start = slot?.start_time || "00:00";
						const end = slot?.end_time || "23:59";
						return currentTime >= start && currentTime <= end;
					});
				});
			});
		};
		const isRecordActive = (rec) => rec && rec.status !== false && rec.status !== "false";
		const filteredCategories = allGlobalCategories.filter((cat) => passesScheduler(cat) && isRecordActive(cat));

		// Dedupe addons by addon_group_id, filtering out inactive addon groups and addon items.
		const uniqueAddons = [];
		const addonGroupIds = new Set();
		allAddonsFlat.forEach((addon) => {
			if (isRecordActive(addon) && !addonGroupIds.has(addon.addon_group_id)) {
				addonGroupIds.add(addon.addon_group_id);
				const cleanAddonItems = (addon.addon_item || []).filter(isRecordActive);
				uniqueAddons.push({
					...addon,
					addon_item: cleanAddonItems,
				});
			}
		});

		// --- Items + variants: filter by scheduler + dietary + status !== false + active category, apply channel PLU ---
		const inactiveCatIds = new Set(
			allGlobalCategories
				.filter((cat) => !passesScheduler(cat) || !isRecordActive(cat))
				.map((cat) => String(cat?.category_id || cat?._id))
		);
		const isItemActive = (item) => {
			if (!isRecordActive(item)) return false;
			if (item.category_id && inactiveCatIds.has(String(item.category_id))) return false;
			return true;
		};
		const dataItem = allGlobalItems.filter((item) => passesScheduler(item) && isItemActive(item));
		const filterLocal = JSON.parse(localStorage.getItem("filter") || "null");
		const itemData = filterLocal?.dietary
			? dataItem.filter((item) => item && (item.dietary === filterLocal.dietary || !item.dietary))
			: dataItem.filter(Boolean);

		let activeChannelCode = reducerState?.orderType?.order?.order_code;
		if (!activeChannelCode) {
			const locId = sessionState?.location_id;
			if (locId?.toLowerCase() === "ta") activeChannelCode = "TA";
			else if (locId) activeChannelCode = "DI";
		}

		const allItemVerriant = [];
		allGlobalItems.forEach((item) => {
			if (!isRecordActive(item) || !passesScheduler(item)) return;
			(item.item_variant || []).forEach((variant) => {
				if (isRecordActive(variant)) {
					allItemVerriant.push({ ...item, item_variant: [variant] });
				}
			});
		});

		const updatedVariants = itemData.map((item) => {
			const updatedItemVariants = (item.item_variant || []).map((variant) => {
				return variant;
			});
			return { ...item, item_variant: updatedItemVariants };
		});

		// --- Legacy reducer dispatches commented out — catalogReducer is the source of truth.
		// Restore these if a screen still reads from `state.customerReducer.{item_list, catagory, addon,
		// item_verriants, loaded_stores}`. Tracked in project_fsr_migration_pending.md.
		const loadedIds = _storesToFetch.map((s) => String(s.store_id));
		// dispatch({ type: 'CATEGORY_LIST', catagory: filteredCategories });
		// dispatch({ type: 'ADDON_LIST', addon: uniqueAddons });
		// dispatch({ type: 'ITEM_LIST', item_list: updatedVariants });
		// dispatch({ type: 'ITEM_VERRIANTS', item_verriants: allItemVerriant });
		// dispatch({ type: 'LOADED_STORES', loaded_stores: loadedIds });

		// --- catalogReducer: single batched dispatch keyed by store_id ---
		const groupByStore = (arr) =>
			(arr || []).reduce((acc, x) => {
				const k = String(x?.store_id);
				if (!k || k === 'undefined') return acc;
				(acc[k] = acc[k] || []).push(x);
				return acc;
			}, {});
		const itemsByStore    = groupByStore(updatedVariants);
		const variantsByStore = groupByStore(allItemVerriant);
		const catsByStore     = groupByStore(filteredCategories);
		const addonsByStore   = groupByStore(uniqueAddons);

		const storeIds = new Set([
			...Object.keys(itemsByStore),
			...Object.keys(variantsByStore),
			...Object.keys(catsByStore),
			...Object.keys(addonsByStore),
			...loadedIds,
		]);
		const by_store = {};
		storeIds.forEach((sid) => {
			by_store[sid] = {
				items:         itemsByStore[sid]    || [],
				categories:    catsByStore[sid]     || [],
				addons:        addonsByStore[sid]   || [],
				item_variants: variantsByStore[sid] || [],
			};
		});
		console.log('[preload] dispatching CATALOG_LOAD_ALL', {
			store_count: Object.keys(by_store).length,
			ids: Object.keys(by_store),
		});
		dispatch({
			type: 'CATALOG_LOAD_ALL',
			by_store,
			loaded_stores: Array.from(storeIds),
		});
		} finally {
			isPreloading = false;
		}
	};
};

export {
	clear_associated_store,
    item_list,applied_offer,
    item_verriant_list,
    item_category,
    set_filters,
    addon_list,
    label_list,
	preload_menu_data,
	get_store_configs,
	clear_applied_offer,
    clear_order_type,
    clear_last_order,
    set_order_type,
    set_last_order,
    clear_order_details,
    clear_customer,
    set_customer,
    set_tender,
    store_details,   
	store_configs,
    order_request,
    order_place,
    clearStateData,
    set_user,
    update_user,
    captured_image,
    save_share_image,
	clear_order_request,
    store_offers,
	customer_membership,
	associated_stores,
    web_login,
    web_logout,
};
